import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_switch_on.svg';
import Icon, { IconProps } from './icon';

const IconSwitchOn = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconSwitchOn;
